import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punestationtomumbaicabservice() {



  const cardData =
  {
    keyword: ' Pune Station to Mumbai Cabs Service',
    heading: 'Sai Trupti Cabs: Pune Station to Mumbai Cabs Service',
    headingDescription: 'Sai Trupti Cabs offers convenient and reliable Pune Station to Mumbai cab services, ensuring a comfortable and hassle-free journey for every traveler. Our fleet of clean, air-conditioned Sedans, SUVs, and Luxury cars provides the perfect combination of comfort, safety, and affordability for long-distance travel. Whether you’re heading to Mumbai city, Navi Mumbai, or Mumbai Airport, our professional and background-verified chauffeurs ensure punctual pickups directly from Pune Railway Station and guarantee smooth, safe driving throughout the trip. With transparent pricing, flexible one-way and round-trip options, and 24×7 customer support, Sai Trupti Cabs makes intercity travel simple and dependable. Enjoy a seamless ride from Pune Station to Mumbai with Sai Trupti Cabs — your trusted partner for reliable and comfortable cab services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune Station to Mumbai Cabs Service",
    "description": "Pune Station to Mumbai Cabs Service provides reliable and comfortable travel solutions from Pune Station to Mumbai with a fleet of well-maintained vehicles, professional drivers, air-conditioned comfort, door-to-door service, online booking, transparent fares, real-time ride tracking, and 24/7 customer support for a hassle-free journey."
  },
  {
    "name": "Pune Station to Mumbai Taxi",
    "description": "Pune Station to Mumbai Taxi offers convenient taxi services with experienced chauffeurs, spacious seating, air-conditioned vehicles, transparent pricing, online booking, and 24/7 assistance for one-way trips, airport transfers, and outstation travel."
  },
  {
    "name": "Pune Station to Mumbai Car Hire",
    "description": "Pune Station to Mumbai Car Hire provides flexible car rental options for self-drive or chauffeur-driven trips. Features include air-conditioned vehicles, professional drivers, transparent fares, online booking, and 24/7 customer support for stress-free travel."
  },
  {
    "name": "Pune Station to Mumbai Innova Cab",
    "description": "Pune Station to Mumbai Innova Cab offers spacious and comfortable travel with air-conditioned interiors, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 support, perfect for families, groups, and business travelers."
  },
  {
    "name": "Pune Station to Mumbai Ertiga Cab",
    "description": "Pune Station to Mumbai Ertiga Cab ensures smooth and comfortable travel with spacious, air-conditioned vehicles suitable for small families and groups. Features include professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 assistance."
  },
  {
    "name": "Pune Station to Mumbai Sedan Cab",
    "description": "Pune Station to Mumbai Sedan Cab provides professional intercity travel in comfortable sedans with air-conditioned interiors, experienced chauffeurs, online booking, transparent fares, and 24/7 support for airport transfers, one-way trips, and outstation journeys."
  },
  {
    "name": "Pune Station to Mumbai One Way Taxi",
    "description": "Pune Station to Mumbai One Way Taxi offers convenient one-way travel with air-conditioned vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 customer assistance for a seamless journey."
  },
  {
    "name": "Pune Station to Mumbai Drop Cab",
    "description": "Pune Station to Mumbai Drop Cab provides reliable door-to-door drop services with spacious, air-conditioned vehicles, professional chauffeurs, online booking, transparent fares, and 24/7 support for stress-free travel."
  },
  {
    "name": "Pune Station to Mumbai Airport Taxi",
    "description": "Pune Station to Mumbai Airport Taxi offers dedicated airport transfers with timely pickups, air-conditioned vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 customer support for hassle-free airport travel."
  },
  {
    "name": "Pune Station to Mumbai Outstation Cab",
    "description": "Pune Station to Mumbai Outstation Cab provides reliable long-distance travel with air-conditioned vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 support for smooth intercity journeys."
  },
  {
    "name": "Affordable Pune Station to Mumbai Taxi",
    "description": "Affordable Pune Station to Mumbai Taxi offers cost-effective travel options without compromising on comfort. Features include air-conditioned vehicles, professional drivers, online booking, transparent fares, and 24/7 support for convenient trips."
  },
  {
    "name": "Pune Station to Mumbai Luxury Cab",
    "description": "Pune Station to Mumbai Luxury Cab provides premium travel in plush, air-conditioned vehicles with professional chauffeurs, online booking, transparent fares, real-time ride tracking, and 24/7 support for a luxurious travel experience."
  },
  {
    "name": "Pune Station to Mumbai Online Cab Booking",
    "description": "Pune Station to Mumbai Online Cab Booking allows quick and convenient reservations via an online platform. Features include instant confirmation, multiple vehicle options, transparent pricing, real-time ride tracking, and 24/7 customer assistance for seamless travel."
  },
  {
    "name": "Pune Station to Mumbai Taxi near Me",
    "description": "Pune Station to Mumbai Taxi near Me provides easy access to nearby taxi services for intercity travel. Services include air-conditioned vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 customer support."
  },
  {
    "name": "Pune Station to Mumbai Travel Service",
    "description": "Pune Station to Mumbai Travel Service offers comprehensive travel solutions including one-way trips, round trips, airport transfers, and outstation journeys. Features include air-conditioned vehicles, professional drivers, online booking, transparent fares, real-time ride tracking, and 24/7 assistance."
  }
],
"tableData": [
  ["Pune Station to Mumbai Cabs Service", "Pune Station to Mumbai Taxi"],
  ["Pune Station to Mumbai Car Hire", "Pune Station to Mumbai Innova Cab"],
  ["Pune Station to Mumbai Ertiga Cab", "Pune Station to Mumbai Sedan Cab"],
  ["Pune Station to Mumbai One Way Taxi", "Pune Station to Mumbai Drop Cab"],
  ["Pune Station to Mumbai Airport Taxi", "Pune Station to Mumbai Outstation Cab"],
  ["Affordable Pune Station to Mumbai Taxi", "Pune Station to Mumbai Luxury Cab"],
  ["Pune Station to Mumbai Online Cab Booking", "Pune Station to Mumbai Taxi near Me"],
  ["Pune Station to Mumbai Travel Service", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune Station to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services starting from Pune Railway Station to Mumbai, ideal for business trips, airport transfers and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fare",
    "WhyChoosedescription": "We provide clear one‑way fares from Pune Station to Mumbai with no hidden charges — starting from around ₹1,600 for a sedan based on market rates. :contentReference[oaicite:0]{index=0}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Pune Station to Mumbai route."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers know the route from Pune Station to Mumbai well and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop‑off Locations",
    "WhyChoosedescription": "We provide convenient pickup at Pune Railway Station (and surrounding areas) and drop‑off across Mumbai — including airports, railway stations and city locations."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our cars are regularly serviced, sanitized and maintained to provide a comfortable ride over the long distance from Pune Station to Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, modifications or travel queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your ‘Pune Station to Mumbai’ cab easily via call, WhatsApp or our website — with instant confirmation and prompt vehicle dispatch."
  }
]


































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune Station to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune Station to Mumbai cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Pune Station to Mumbai cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune Station to Mumbai cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune Station to Mumbai?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for the Pune Station to Mumbai route?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Pune Station–Mumbai route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Pune Station to Mumbai for airport or corporate travel?',
    answer: 'Certainly. Our cab services cater to airport transfers, corporate trips, sightseeing, and personal travel between Pune Station and Mumbai.',
  },
  {
    question: 'Is the Pune Station to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pune Station to Mumbai for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Pune Station to Mumbai cab fares?',
    answer: 'Our cab fares start from ₹1,900 for hatchbacks, ₹2,200–₹3,000 for sedans, and ₹3,500 onwards for SUVs and Innova Crysta, depending on vehicle type and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune Station to Mumbai cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune Station to Mumbai cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a safe journey.',
  },
  {
    question: 'Is customer support available during the Pune Station to Mumbai cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune Station to Mumbai cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rakesh Kulkarni',
    feedback: 'I booked a Pune Station to Mumbai cab with Sai Trupti Cabs. The journey was comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shreya Patil',
    feedback: 'Sai Trupti Cabs made my Pune Station to Mumbai trip smooth and hassle-free. Excellent service and punctual driver.',
    rating: 5,
  },
];





























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Station to Mumbai Cabs Service",
  "image": "https://saitrupticabs.com/assets/images/pune-station-to-mumbai-cab.jpg",
  "description": "Book Pune Station to Mumbai Cab with Sai Trupti Cabs for safe, reliable, and comfortable travel. Perfect for one-way trips, airport transfers, or outstation rides. Choose AC sedans, SUVs, or Innova with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-station-to-mumbai-cab"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune Station to Mumbai Cabs Service | Safe & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Station to Mumbai Cab with Sai Trupti Cabs for safe, reliable, and comfortable travel. Perfect for one-way trips, airport transfers, or outstation rides. Choose AC sedans, SUVs, or Innova with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune Station to Mumbai Cabs Service, Pune Station to Mumbai Taxi, Pune Station to Mumbai Car Hire, Pune Station to Mumbai Innova Cab, Pune Station to Mumbai Ertiga Cab, Pune Station to Mumbai Sedan Cab, Pune Station to Mumbai One Way Taxi, Pune Station to Mumbai Drop Cab, Pune Station to Mumbai Airport Taxi, Pune Station to Mumbai Outstation Cab, Affordable Pune Station to Mumbai Taxi, Pune Station to Mumbai Luxury Cab, Pune Station to Mumbai Online Cab Booking, Pune Station to Mumbai Taxi near Me, Pune Station to Mumbai Travel Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punestationtomumbaicabservice;